import React, {PureComponent} from 'react'
import injectSheet from 'react-jss'
import CentredContentContainer from "../Widgets/CentredContentContainer"
import Heading from "../Widgets/Heading"
import FaqItem from "./FaqItem"
import theme from "../../styles/theme"

const DEFAULT_TITLE_TAG = 'h2';
const DEFAULT_QUESTION_TAG = 'h3';

class FaqSlice extends PureComponent {
    render() {
        const {classes, item: {id, id_prefix, title, title_tag, question_tag, items}} = this.props;

        if (!items || items.length === 0) return null;

        return (
            <CentredContentContainer>
                <section id={id || undefined} className={classes.container}>
                    {title && <Heading tag={title_tag || DEFAULT_TITLE_TAG} className={classes.title}>{title}</Heading>}
                    {items.map((faq, index) => (
                        <FaqItem
                            key={index}
                            item={faq}
                            questionTag={question_tag || DEFAULT_QUESTION_TAG}
                            idPrefix={`${id_prefix}-${index}`}
                        />
                    ))}
                </section>
            </CentredContentContainer>
        )
    }
}

export default injectSheet({
    container: {
        marginBottom: theme.spacing.large,
    },
    title: {
        textAlign: 'center',
        marginBottom: theme.spacing.small,
    },
})(FaqSlice)



// WEBPACK FOOTER //
// ./src/components/Article/FaqSlice.js